import React from 'react';
import { CssBaseline, Box } from '@mui/material';
import AdminHeader from './AdminHeader';
import AdminMain from './AdminMain';
import { AdminPageContextProvider } from '../Context';
import { AdminLanguageProvider } from './AdminI18n';

function Admin() {
  return (
    <AdminPageContextProvider>
      <AdminLanguageProvider>
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          <AdminHeader />
          <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <AdminMain />
          </Box>
        </Box>
      </AdminLanguageProvider>
    </AdminPageContextProvider>
  );
}

export default Admin;